import { createContext, use } from 'react'

export const InlineErrorContext = createContext<{ error: unknown }>({ error: null })

export function useInlineErrorContext() {
  const context = use(InlineErrorContext)
  if (!context) {
    throw new Error('InlineErrorContext not found')
  }
  return context
}
